module.exports = __webpack_public_path__ + "static/focus-group-6819aefd2daf23e2df13aac6bda42d0e.png";